import { useLayoutEffect } from "react";

const QRHandler = () => {
  const handleOpenApp = () => {
    const originalUrl = window.location.href;
    const parsedURL = new URL(originalUrl);
    let redirecturl = parsedURL.origin;
    const type = parsedURL.searchParams.get('t');
    if(type == "pf" || type == "wb"){
        redirecturl = redirecturl + "/portfolio";
        const orgid = parsedURL.searchParams.get('o');
        const folderid = parsedURL.searchParams.get('f');
        if(orgid){
            redirecturl = redirecturl + "/orgId=" + orgid;
        }
        if(type == "pf"){
          redirecturl = redirecturl+"?type=portfolio"
        }
        else{
          redirecturl = redirecturl+"?type=workbook"
        }
        if(folderid){
          redirecturl = redirecturl+"&folderId="+folderid;
        }
        redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app");
        window.location.href = redirecturl;
    }
    else if(type == "as"){
        const assetID = parsedURL.searchParams.get('a');
        if(assetID){
            redirecturl = redirecturl +"/asset/assets/"+assetID;
            redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app")
            window.location.href = redirecturl;
        }
    }
    else if(type == "ap"){
        const partID = parsedURL.searchParams.get('p');
        if(partID){
            redirecturl = redirecturl +"/assetPart/parts/"+partID;
            redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app")
            window.location.href = redirecturl;
        }
    }
    else if(type == "dc" || type == "dci"){
        const id = parsedURL.searchParams.get('i');
        let idPath = decodeURIComponent(id);
        idPath = idPath.replace(/\/$/, '');
        if(type == "dc"){
          redirecturl = redirecturl + "/document/" + idPath;
        }
        else{
          redirecturl = redirecturl + "/internal/document/0/" + idPath;
        }
        redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app")
        window.location.href = redirecturl;
    }
  };


  const handleContinueBrowser = () => {
    const originalUrl = window.location.href;
    const parsedURL = new URL(originalUrl);
    let redirecturl = parsedURL.origin;
    const type = parsedURL.searchParams.get('t');
    if(type == "pf" || type == "wb"){
        redirecturl = redirecturl + "/portfolio";
        const orgid = parsedURL.searchParams.get('o');
        const folderid = parsedURL.searchParams.get('f');
        if(orgid){
            redirecturl = redirecturl + "/orgId/" + orgid;
        }
        redirecturl = new URL(redirecturl);
        if(type == "pf"){
            redirecturl.searchParams.set('type', "portfolio");
        }
        else{
            redirecturl.searchParams.set('type', "workbook");
        }
        if(folderid) redirecturl.searchParams.set('folderId', folderid);
        window.location.replace(redirecturl.toString());
    }
    else if(type == "as"){
        const assetID = parsedURL.searchParams.get('a');
        if(assetID){
            redirecturl = redirecturl +"/asset/"+assetID;
            window.location.replace(redirecturl.toString());
        }
    }
    else if(type == "ap"){
        const partID = parsedURL.searchParams.get('p');
        if(partID){
            redirecturl = redirecturl +"/assetPart/"+partID;
            window.location.replace(redirecturl.toString());
        }
    }
    else if(type == "dc" || type == "dci"){
        const id = parsedURL.searchParams.get('i');
        const idPath = decodeURIComponent(id);
        if(type == "dc"){
          redirecturl = redirecturl + "/document/" + idPath;
        }
        else{
          redirecturl = redirecturl + "/internal/document/0/" + idPath;
        }
        window.location.replace(redirecturl.toString());
    }
  };

  // AUTO REDIRECT (no UI)
  useLayoutEffect(() => {
    handleOpenApp();

    const timer = setTimeout(() => {
      handleContinueBrowser();
    }, 1200); // fallback if app not installed

    return () => clearTimeout(timer);
  }, []);


  return null; // nothing rendered → no blink UI
};

export default QRHandler;



// const QRHandler = () => {
//     const handleOpenApp = () => {
//       const originalUrl = window.location.href;
//         const parsedURL = new URL(originalUrl);
//         let redirecturl = parsedURL.origin;
//         const type = parsedURL.searchParams.get('t');
//         if(type == "pf" || type == "wb"){
//             redirecturl = redirecturl + "/portfolio";
//             const orgid = parsedURL.searchParams.get('o');
//             const folderid = parsedURL.searchParams.get('f');
//             if(orgid){
//                 redirecturl = redirecturl + "/orgId=" + orgid;
//             }
//             if(type == "pf"){
//               redirecturl = redirecturl+"?type=portfolio"
//             }
//             else{
//               redirecturl = redirecturl+"?type=workbook"
//             }
//             if(folderid){
//               redirecturl = redirecturl+"&folderId="+folderid;
//             }
//             redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app");
//             // window.location.href = redirecturl;
//             window.open(redirecturl);
//         }
//         else if(type == "as"){
//             const assetID = parsedURL.searchParams.get('a');
//             if(assetID){
//                 redirecturl = redirecturl +"/asset/assets/"+assetID;
//                 redirecturl = redirecturl.toString();
//                 redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app")
//                 // window.location.href = redirecturl;
//                 window.open(redirecturl);
//             }
//         }
//         else if(type == "ap"){
//             const partID = parsedURL.searchParams.get('p');
//             if(partID){
//                 redirecturl = redirecturl +"/assetPart/parts/"+partID;
//                 redirecturl = redirecturl.toString();
//                 redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app")
//                 // window.location.href = redirecturl;
//                 window.open(redirecturl);
//             }
//         }
//         else if(type == "dc" || type == "dci"){
          
//           redirecturl = redirecturl.toString();
//           const id = parsedURL.searchParams.get('i');
//            let idPath = decodeURIComponent(id);
//            idPath = idPath.replace(/\/$/, '');
//           if(type == "dc"){
//             redirecturl = redirecturl + "/document/" + idPath;
//           }
//           else{
//             redirecturl = redirecturl + "/internal/document/0/" + idPath;
//           }
//           redirecturl = redirecturl.toString();
//           redirecturl = redirecturl.replace(parsedURL.origin,"amniusconnect://app")
//           // window.location.href = redirecturl;
//           window.open(redirecturl);
//         }
//     };

    
//     const handleContinueBrowser = () => {
//         const originalUrl = window.location.href;
//         const parsedURL = new URL(originalUrl);
//         let redirecturl = parsedURL.origin;
//         const type = parsedURL.searchParams.get('t');
//         if(type == "pf" || type == "wb"){
//             redirecturl = redirecturl + "/portfolio";
//             const orgid = parsedURL.searchParams.get('o');
//             const folderid = parsedURL.searchParams.get('f');
//             if(orgid){
//                 redirecturl = redirecturl + "/orgId/" + orgid;
//             }
//             redirecturl = new URL(redirecturl);
//             if(type == "pf"){
//                 redirecturl.searchParams.set('type', "portfolio");
//             }
//             else{
//                 redirecturl.searchParams.set('type', "workbook");
//             }
//             if(folderid) redirecturl.searchParams.set('folderId', folderid);
//             // window.location.href = redirecturl.toString();
//             window.location.replace(redirecturl.toString());
//         }
//         else if(type == "as"){
//             const assetID = parsedURL.searchParams.get('a');
//             if(assetID){
//                 redirecturl = redirecturl +"/asset/"+assetID;
//                 // window.location.href = redirecturl.toString();
//                 window.location.replace(redirecturl.toString());
//             }
//         }
//         else if(type == "ap"){
//             const partID = parsedURL.searchParams.get('p');
//             if(partID){
//                 redirecturl = redirecturl +"/assetPart/"+partID;
//                 // window.location.href = redirecturl.toString();
//                 window.location.replace(redirecturl.toString());
//             }
//         }
//         else if(type == "dc" || type == "dci"){
//           redirecturl = redirecturl.toString();
//           const id = parsedURL.searchParams.get('i');
//            const idPath = decodeURIComponent(id);
//           if(type == "dc"){
//             redirecturl = redirecturl + "/document/" + idPath;
//           }
//           else{
//             redirecturl = redirecturl + "/internal/document/0/" + idPath;
//           }
//           // window.location.href = redirecturl.toString();
//           window.location.replace(redirecturl.toString());
//         }
//     };

//   return (
//     <div style={styles.container}>
//       <a onClick={handleOpenApp} style={{ ...styles.button, ...styles.openButton }}>
//         Open in App
//       </a>
//       <a onClick={handleContinueBrowser} style={{ ...styles.button, ...styles.continueButton }}>
//         Continue in Browser
//       </a>
//     </div>
//   )
// }

// // Simple inline styles
// const styles = {
//     container: {
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       height: '100vh',
//       backgroundColor: '#f0f0f0',
//       flexDirection: 'column',
//     },
//     button: {
//       display: 'inline-block',
//       padding: '10px 20px',
//       margin: '10px',
//       fontSize: '16px',
//       border: 'none',
//       borderRadius: '5px',
//       textDecoration: 'none',
//       cursor: 'pointer',
//       transition: 'background-color 0.3s ease',
//       color: '#fff',
//     },
//     openButton: {
//       backgroundColor: '#007bff',
//     },
//     continueButton: {
//       backgroundColor: '#28a745',
//     },
//   };

// export default QRHandler